import React, { useState } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { IGetApprovalForms } from './types';
import { styles } from './styles';
import { useDebouncedCallback } from 'use-debounce';

export default function Search({
  setSearch,
  getApprovalForms,
  archived
}: {
  setSearch: (query: string) => void;
  getApprovalForms: IGetApprovalForms;
  archived: boolean;
}) {
  const [tempSearch, setTempSearch] = useState('');
  const debouncedAPICall = useDebouncedCallback((searchQuery) => {
    getApprovalForms(1, null, searchQuery, null, null, archived);
    sessionStorage.setItem(`approvalFormsTablePage`, '1');
    setSearch(searchQuery);
  }, 600);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTempSearch(event.target.value);
    debouncedAPICall(event.target.value);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <FormControl fullWidth>
        <OutlinedInput
          id="applicant-search"
          sx={styles.searchInput}
          placeholder={'Search by title or ID'}
          value={tempSearch}
          onChange={handleChange}
          startAdornment={
            <InputAdornment sx={{ padding: '0px 0px 0px 14px' }} position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </FormControl>
    </Box>
  );
}
